import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { Documento } from '../shared/documento.model';
import { TYPEMODULE, LoaderService, NotificationService, UtilityService, ErrorService, CONSTANT } from '../../../../shared/session/index';
import { DocumentoService } from '../shared/documento.service';
import { FileuploadComponent } from 'src/app/shared/fileupload/fileupload.component';

@Component({
  //moduleId: module.id,
  selector: 'app-documento-view',
  templateUrl: 'documento-view.component.html'
})
export class DocumentoViewComponent implements OnInit {
  @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
  @ViewChild(FileuploadComponent) fileuploadComponent: FileuploadComponent;
  @Input() typeModule: TYPEMODULE;
  @Input() titlePage: string;
  @Input() data: any;
  // @Input() ID:number;

  documento: Documento;
  msgErrorGet: string;
  public typeImage: number;

  constructor(private loaderService: LoaderService,
    private documentoService: DocumentoService,
    private errorService: ErrorService,
    private notificationService: NotificationService,
    private utilityService: UtilityService) { }

  ngOnInit() {
    this.documento = new Documento(1, "", "", "", true, "", "", "", "", "", "");
    this.msgErrorGet = 'Error al obtener datos';
    this.typeImage = CONSTANT.typeImage.view;
    this.obtenerDocumento(this.data.documento.ID);
  }

  private obtenerDocumento(documentoID: number): void {
    this.loaderService.show();
    this.documentoService.obtenerDocumento(documentoID)
      .subscribe(res => {
        this.documento = res;
        this.utilityService.setAuditoria(this.documento);
        this.fileuploadComponent.getFile(CONSTANT.imagen.clase.documento, CONSTANT.imagen.tipo.usuario, this.documento.FotoRuta);
      },
        error => {
          this.notificationService.error(this.msgErrorGet);
          throw error;
        },
        () => {
          this.loaderService.hide();
        });
  }
}
